import "./index.scss";
import LogoM from "../../../assets/images/logo-m.png";
const Logo = () => {
  return (
    <div className="logo-container">
      <img className="solid-logo" src={LogoM} alt="M" />
    </div>
  );
};
export default Logo;
